import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './Input.module.css';
import inputMessageStyles from './InputMessage.module.css';
export function Input(props) {
    const { size, label, description, error, success, leftElement, rightElement, dataTestId, inputRef, className, containerClassName, ...inputProps } = props;
    const messageIdBase = props.id ?? dataTestId;
    const errorId = `${messageIdBase}-error`;
    const successId = `${messageIdBase}-success`;
    const descriptionId = `${messageIdBase}-description`;
    const describedBy = [
        inputProps['aria-describedby'],
        error ? errorId : undefined,
        success ? successId : undefined,
        !error && !success && description ? descriptionId : undefined,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: [styles.container, size === 'small' ? styles.small : styles.large].filter(Boolean).join(' '), children: [label && (_jsx("label", { className: styles.label, htmlFor: props.id, children: label })), _jsxs("div", { className: [
                    styles.inputContainer,
                    inputProps.disabled ? styles.disabled : '',
                    inputProps.readOnly ? styles.readonly : '',
                    error ? styles.error : '',
                    !error && success ? styles.success : '',
                    inputProps.value !== undefined && `${inputProps.value}`.length > 0 && inputProps.disabled
                        ? styles.filled
                        : '',
                    containerClassName,
                ]
                    .filter(Boolean)
                    .join(' '), children: [leftElement && (_jsx("span", { className: styles.left, "aria-hidden": 'true', children: leftElement })), _jsx("input", { "data-testid": dataTestId, id: props.id, className: [
                            styles.input,
                            leftElement ? styles.hasLeftElement : styles.noLeftElement,
                            rightElement ? styles.hasRightElement : styles.noRightElement,
                            className,
                        ]
                            .filter(Boolean)
                            .join(' '), ref: inputRef, ...inputProps, "aria-describedby": describedBy || undefined, "aria-invalid": inputProps['aria-invalid'] ?? (error ? true : undefined) }), rightElement && (_jsx("span", { className: styles.right, "aria-hidden": 'true', children: rightElement }))] }), error && (_jsxs("div", { className: inputMessageStyles.messageContainer, children: [_jsx(Icon, { name: 'inputError', alt: 'Error', className: inputMessageStyles.messageIcon }), _jsx("p", { id: errorId, className: inputMessageStyles.message, children: error })] })), success && (_jsxs("div", { className: inputMessageStyles.messageContainer, children: [_jsx(Icon, { name: 'checkMarkCircle', alt: 'Success', className: inputMessageStyles.messageIcon }), _jsx("p", { id: successId, className: inputMessageStyles.message, children: success })] })), !error && !success && description && (_jsx("p", { id: descriptionId, className: inputMessageStyles.message, children: description }))] }));
}
